import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { EditIntegrationRequest } from '@/types/request/EditIntegrationRequest';
import { queryClient } from '@/main.tsx';

const useIntegrationEdit = () => {
  const client = supabaseClient;

  const mutationFn = async (request: EditIntegrationRequest) => {
    return editIntegration(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integrations'] });
    },
  });
};

export default useIntegrationEdit;

async function editIntegration(client: SupabaseClient, request: EditIntegrationRequest): Promise<void> {
  const { data, error } = await client
    .from('integrations')
    .update(request)
    .eq('id', request.id)
    .select('id')
    .maybeSingle();

  if (error) throw new Error(error.message);
  if (!data) throw new Error('Failed to update Integration. Try with different values.');

  return;
}
